import React from 'react';
import './App.css';
import 'antd/dist/antd.css';
import {Route, Router, Routes} from 'react-router-dom';

import AppHeader from './components/common/header';
import AppFooter from './components/common/footer';
import AppHome from './views/home';
import { Layout } from 'antd';
import Documentation from './components/home/Documentation';
import Sandbox from './components/home/Sandbox';
import AppFaq from './components/home/faq';
import AppContact from './components/home/contact';
import AppFeature from './components/home/feature';
import SignIn from './components/home/SignIn';
import SignUp from './components/home/SignUp';
import Profile from './components/home/Profile';
import KycDetails from './components/home/KycDetails';
import Collection from './components/home/Collection';
import ApiParameters from './components/home/ApiParameters';
import MyCollection from './components/home/MyCollection';
import SignUpSuccess from './components/home/SignUpSuccess';
import AdminPanel from './components/admin/AdminPanel';
import LiveRequests from './components/admin/LiveRequests';
import ApprovedClients from './components/admin/ApprovedClients';
const { Header, Content, Footer } = Layout;

function App() {
  return (
    <Layout className="mainLayout" style={{minHeight:'100vh'}}>
      <Header style={{boxShadow: '0 8px 5px rgb(0 0 0 / 5%)'}}>
        <AppHeader/>
      </Header>
      <Content>
      <Routes>
          <Route exact path="/" element={<AppHome/>}/>
          <Route exact path="/Documentation" element={<Documentation />}/>
          <Route exact path="/Sandbox" element={<Sandbox />}/>
          <Route exact path="/Products" element={<AppFeature />}/>
          <Route exact path="/FAQS" element={<AppFaq />}/>
          <Route exact path="/Contact" element={<AppContact />}/>
          <Route exact path="/SignIn" element={<SignIn />}/>
          <Route exact path="/SignUp" element={<SignUp />}/>
          <Route exact path="/SignUpSuccess" element={<SignUpSuccess/>}/>
          <Route exact path="/Profile" element={<Profile/>}/>
          <Route exact path="/KycDetails" element={<KycDetails />}/>
          <Route exact path="/ApiParameters" element={<ApiParameters />}/>
          <Route exact path="/Collections" element={<Collection />}/>
          <Route exact path="/MyCollection" element={<MyCollection />}/>
          <Route exact path="/AdminPanel" element={<AdminPanel />}/>
          <Route exact path="/LiveRequests" element={<LiveRequests />}/>
          <Route exact path="/ApprovedClients" element={<ApprovedClients />}/>
      </Routes>
      </Content>
      <Footer style={{bottom:0,width:'100%'}}>
        <AppFooter/>  
      </Footer>      
    </Layout>
  );
}

export default App;
